module.exports = "//static.hsappstatic.net/ui-addon-upgrades/static-9.18424/js/img/valuePropModals/ReportBuilder/ValueProp3.svg"